import React, { useContext, useEffect, useMemo, useState } from "react";
import Formula3DPreview from "../../FormulaGenerator/Formula3DPreview";
import "./index.scss";
import BarInfo from "../../mediaContent/barInfo";
import { getTargetAlternateKey } from "../alternateConstruction";
import { getAvailableSidesByStep } from "../../FormulaGenerator/formulaHelpers";
import { Button, ButtonGroup } from "@mui/material";
import { StepContext } from "../StepContext";
import { useTranslation } from "../../i18n";

const FinishStep = ({
  stepId
}) => {
  const {
    _t,
    language
  } = useTranslation();
  const {
    goToStep,
    openVideoViewer,
    toggleBottomBarInfo,
    dentalData,
    initialDentalData,
    isPatient,
    patientGender,
    patientFace
  } = useContext(StepContext);
  const availableSwitchers = useMemo(() => {
    return getAvailableSidesByStep(stepId);
  }, [stepId]);
  const alternateText = useMemo(() => {
    switch (stepId) {
      case "PSP_ET_e1_e2_adenty_adentyTop_adentyTopGum":
      case "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomGum":
      case "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothGum":
        return _t("Обратите внимание, что полный съемный протез является лишь временным решением. Хотите изучить постоянное решение?");

      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_fixedProsthetics_suspendedToothSelect_extraCrownsSelect_extraVeneersSelect_compositeRestorations_toothConnections_finishStep":
        return _t("Обратите внимание, что мостовидный протез требует обработки здоровых зубов под коронки для создания опоры. Данный подход не считается самым приемлемым в современной стоматологии.  Хотите изучить альтернативное решение?");

      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseTop_extraCrownsSelect_compositeRestorations_finishStep":
      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBottom_extraCrownsSelect_compositeRestorations_finishStep":
      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBoth_extraCrownsSelect_compositeRestorations_finishStep":
      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseTop_extraCrownsSelect_compositeRestorations_finishStep":
      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBottom_extraCrownsSelect_compositeRestorations_finishStep":
      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBoth_extraCrownsSelect_compositeRestorations_finishStep":
        return _t("Обратите внимание, что съемный протез является лишь временным решением. Долговременное использование таких протезов ведет к атрофии слизистой и кости, что усложняет протезирование в дальнейшем. Хотите изучить постоянное решение?");

      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_screwFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations_implantationSelectFalseTeethConnection_finishStep":
      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_cementFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations_implantationSelectFalseTeethConnection_finishStep":
      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_multiunutFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations_implantationSelectFalseTeethConnection_finishStep":
      case "PSP_ET_e1_e2_adenty_adentyTop_adentyTopImplant_adentyImplantProsthesisFixation_adentyTopImplant4_cementImplantProsthesisFixationTop4":
      case "PSP_ET_e1_e2_adenty_adentyTop_adentyTopImplant_adentyImplantProsthesisFixation_adentyTopImplant6_cementImplantProsthesisFixationTop6":
      case "PSP_ET_e1_e2_adenty_adentyTop_adentyTopImplant_adentyImplantProsthesisFixation_adentyTopImplant4_multiunitImplantProsthesisFixationTop4":
      case "PSP_ET_e1_e2_adenty_adentyTop_adentyTopImplant_adentyImplantProsthesisFixation_adentyTopImplant6_multiunitImplantProsthesisFixationTop6":
      case "PSP_ET_e1_e2_adenty_adentyTop_adentyTopImplant_adentyImplantProsthesisFixation_adentyTopImplant4_telescopImplantProsthesisFixationTop4":
      case "PSP_ET_e1_e2_adenty_adentyTop_adentyTopImplant_adentyImplantProsthesisFixation_adentyTopImplant6_telescopImplantProsthesisFixationTop6":
      case "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomImplant_adentyImplantProsthesisFixation_adentyBottomImplant4_cementImplantProsthesisFixationBottom4":
      case "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomImplant_adentyImplantProsthesisFixation_adentyBottomImplant6_cementImplantProsthesisFixationBottom6":
      case "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomImplant_adentyImplantProsthesisFixation_adentyBottomImplant4_multiunitImplantProsthesisFixationBottom4":
      case "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomImplant_adentyImplantProsthesisFixation_adentyBottomImplant6_multiunitImplantProsthesisFixationBottom6":
      case "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomImplant_adentyImplantProsthesisFixation_adentyBottomImplant4_telescopImplantProsthesisFixationBottom4":
      case "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomImplant_adentyImplantProsthesisFixation_adentyBottomImplant6_telescopImplantProsthesisFixationBottom6":
      case "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothImplant_adentyImplantProsthesisFixation_adentyBothImplant4_cementImplantProsthesisFixationBoth4":
      case "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothImplant_adentyImplantProsthesisFixation_adentyBothImplant6_cementImplantProsthesisFixationBoth6":
      case "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothImplant_adentyImplantProsthesisFixation_adentyBothImplant4_multiunitImplantProsthesisFixationBoth4":
      case "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothImplant_adentyImplantProsthesisFixation_adentyBothImplant6_multiunitImplantProsthesisFixationBoth6":
      case "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothImplant_adentyImplantProsthesisFixation_adentyBothImplant4_telescopImplantProsthesisFixationBoth4":
      case "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothImplant_adentyImplantProsthesisFixation_adentyBothImplant6_telescopImplantProsthesisFixationBoth6":
        return _t("Имплантация на сегодняшний день является самым лучшим решением для лечения адентии. Для качественной установки имплантов могут понадобиться дополнительные процедуры и вспомогательные устройства.");

      case "PSP_EM_e1_e2_estetic_esCustomVeneers_esCustomCrowns_esCustomRestorations_smileSelect_finishStep":
        return _t("Обратите внимание, что для достижения максимальной эстетики не стоит забывать о форме десен и их здоровье. Современная стоматология имеет много методик, направленных на улучшение формы десен");

      case "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical6Top_esTypicalVeneers_finishStep":
      case "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical8Top_esTypicalVeneers_finishStep":
      case "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical10Top_esTypicalVeneers_finishStep":
      case "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypicalBottom_esTypicalVeneers_finishStep":
      case "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical6Top_esTypicalCrowns_finishStep":
      case "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical8Top_esTypicalCrowns_finishStep":
      case "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical10Top_esTypicalCrowns_finishStep":
      case "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypicalBottom_esTypicalCrowns_finishStep":
      case "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical6Top_esTypicalRestorations_finishStep":
      case "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical8Top_esTypicalRestorations_finishStep":
      case "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical10Top_esTypicalRestorations_finishStep":
      case "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypicalBottom_esTypicalRestorations_finishStep":
        return _t("Во многих случаях ортодонтического лечения, для достижения запланированного результата, используются дополнительные методики и материалы такие как:...");

      case "PSP_OM_e1_e2_orthodonticSelect_orthodonticTreatment_orthoChildTreatment_singleJawApparate_finishStep":
      case "PSP_OM_e1_e2_orthodonticSelect_orthodonticTreatment_orthoChildTreatment_doubleJawApparate_finishStep":
        return _t("Во многих случаях ортодонтического лечения, для достижения запланированного результата, используются дополнительные методики и материалы такие как:...");

      case "PSP_OM_e1_e2_orthodonticSelect_orthodonticTreatment_orthoBasicTreatment_finishStep":
        return _t("Во многих случаях ортодонтического лечения, для достижения запланированного результата, используются дополнительные методики и материалы такие как:...");

      default:
        return false;
    }
  }, [_t, stepId]);

  function openBottomBar() {
    let key = "";

    switch (stepId) {
      case "PSP_ET_e1_e2_adenty_adentyTop_adentyTopGum":
      case "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomGum":
      case "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothGum":
        key = "removableProsthesisAlternate";
        break;

      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_fixedProsthetics_suspendedToothSelect_extraCrownsSelect_extraVeneersSelect_compositeRestorations_toothConnections_finishStep":
        key = "fixedProsthesisAlternate";
        break;

      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseTop_extraCrownsSelect_compositeRestorations_finishStep":
      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBottom_extraCrownsSelect_compositeRestorations_finishStep":
      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBoth_extraCrownsSelect_compositeRestorations_finishStep":
      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseTop_extraCrownsSelect_compositeRestorations_finishStep":
      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBottom_extraCrownsSelect_compositeRestorations_finishStep":
      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBoth_extraCrownsSelect_compositeRestorations_finishStep":
        key = "removableProstheticsAlternate";
        break;

      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_screwFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations_implantationSelectFalseTeethConnection_finishStep":
      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_cementFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations_implantationSelectFalseTeethConnection_finishStep":
      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_implantation_implantFixation_multiunutFixation_extraCrownsSelect_extraVeneersSelect_compositeRestorations_implantationSelectFalseTeethConnection_finishStep":
        key = "optionalImplantationPartialAdentia";
        break;

      case "PSP_ET_e1_e2_adenty_adentyTop_adentyTopImplant_adentyImplantProsthesisFixation_adentyTopImplant4_cementImplantProsthesisFixationTop4":
      case "PSP_ET_e1_e2_adenty_adentyTop_adentyTopImplant_adentyImplantProsthesisFixation_adentyTopImplant6_cementImplantProsthesisFixationTop6":
      case "PSP_ET_e1_e2_adenty_adentyTop_adentyTopImplant_adentyImplantProsthesisFixation_adentyTopImplant4_multiunitImplantProsthesisFixationTop4":
      case "PSP_ET_e1_e2_adenty_adentyTop_adentyTopImplant_adentyImplantProsthesisFixation_adentyTopImplant6_multiunitImplantProsthesisFixationTop6":
      case "PSP_ET_e1_e2_adenty_adentyTop_adentyTopImplant_adentyImplantProsthesisFixation_adentyTopImplant4_telescopImplantProsthesisFixationTop4":
      case "PSP_ET_e1_e2_adenty_adentyTop_adentyTopImplant_adentyImplantProsthesisFixation_adentyTopImplant6_telescopImplantProsthesisFixationTop6":
      case "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomImplant_adentyImplantProsthesisFixation_adentyBottomImplant4_cementImplantProsthesisFixationBottom4":
      case "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomImplant_adentyImplantProsthesisFixation_adentyBottomImplant6_cementImplantProsthesisFixationBottom6":
      case "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomImplant_adentyImplantProsthesisFixation_adentyBottomImplant4_multiunitImplantProsthesisFixationBottom4":
      case "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomImplant_adentyImplantProsthesisFixation_adentyBottomImplant6_multiunitImplantProsthesisFixationBottom6":
      case "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomImplant_adentyImplantProsthesisFixation_adentyBottomImplant4_telescopImplantProsthesisFixationBottom4":
      case "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomImplant_adentyImplantProsthesisFixation_adentyBottomImplant6_telescopImplantProsthesisFixationBottom6":
      case "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothImplant_adentyImplantProsthesisFixation_adentyBothImplant4_cementImplantProsthesisFixationBoth4":
      case "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothImplant_adentyImplantProsthesisFixation_adentyBothImplant6_cementImplantProsthesisFixationBoth6":
      case "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothImplant_adentyImplantProsthesisFixation_adentyBothImplant4_multiunitImplantProsthesisFixationBoth4":
      case "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothImplant_adentyImplantProsthesisFixation_adentyBothImplant6_multiunitImplantProsthesisFixationBoth6":
      case "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothImplant_adentyImplantProsthesisFixation_adentyBothImplant4_telescopImplantProsthesisFixationBoth4":
      case "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothImplant_adentyImplantProsthesisFixation_adentyBothImplant6_telescopImplantProsthesisFixationBoth6":
        key = "optionalImplantationFullAdentia";
        break;

      case "PSP_EM_e1_e2_estetic_esCustomVeneers_esCustomCrowns_esCustomRestorations_smileSelect_finishStep":
      case "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical6Top_esTypicalVeneers_finishStep":
      case "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical8Top_esTypicalVeneers_finishStep":
      case "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical10Top_esTypicalVeneers_finishStep":
      case "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypicalBottom_esTypicalVeneers_finishStep":
      case "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical6Top_esTypicalCrowns_finishStep":
      case "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical8Top_esTypicalCrowns_finishStep":
      case "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical10Top_esTypicalCrowns_finishStep":
      case "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypicalBottom_esTypicalCrowns_finishStep":
      case "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical6Top_esTypicalRestorations_finishStep":
      case "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical8Top_esTypicalRestorations_finishStep":
      case "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical10Top_esTypicalRestorations_finishStep":
      case "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypicalBottom_esTypicalRestorations_finishStep":
        key = "esGumRepair";
        break;

      case "PSP_OM_e1_e2_orthodonticSelect_orthodonticTreatment_orthoChildTreatment_singleJawApparate_finishStep":
      case "PSP_OM_e1_e2_orthodonticSelect_orthodonticTreatment_orthoChildTreatment_doubleJawApparate_finishStep":
      case "PSP_OM_e1_e2_orthodonticSelect_orthodonticTreatment_orthoBasicTreatment_finishStep":
        key = "orthodonticTreatment";
        break;

      default:
        console.error("Unexpected key", stepId);
    }

    if (isPatient) {
      const selectedItem = BarInfo(language).find(el => el.type === key);

      if (selectedItem) {
        openVideoViewer(true, selectedItem.preview.video, selectedItem.title);
      }
    } else {
      toggleBottomBarInfo(true, key);
    }
  }

  function generateFixedConstruction() {
    const key = getTargetAlternateKey(stepId);
    goToStep(key, {});
  }

  const is3dMasksDisabled = useMemo(() => {
    return ["PSP_lowSinus_sinusLifting_boneAugmentation_finishStep"].includes(stepId);
  }, [stepId]);
  const is3dMaskShowed = useMemo(() => {
    return ["PSP_EM_e1_e2_estetic_esCustomVeneers_esCustomCrowns_esCustomRestorations_smileSelect_finishStep", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical6Top_esTypicalVeneers_finishStep", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical8Top_esTypicalVeneers_finishStep", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical10Top_esTypicalVeneers_finishStep", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypicalBottom_esTypicalVeneers_finishStep", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical6Top_esTypicalCrowns_finishStep", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical8Top_esTypicalCrowns_finishStep", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical10Top_esTypicalCrowns_finishStep", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypicalBottom_esTypicalCrowns_finishStep", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical6Top_esTypicalRestorations_finishStep", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical8Top_esTypicalRestorations_finishStep", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypical10Top_esTypicalRestorations_finishStep", "PSP_EM_e1_e2_estetic_esTypicalSelect_esTypicalBottom_esTypicalRestorations_finishStep"].includes(stepId);
  }, [stepId]);
  const isJawStateDisabled = useMemo(() => {
    return ["PSP_lowSinus_sinusLifting_boneAugmentation_finishStep"].includes(stepId);
  }, [stepId]);
  const [formulaPreview, setFormulaPreview] = useState(null);
  const [formulaPreview2, setFormulaPreview2] = useState(null);
  const [previewType, setPreviewType] = useState("afterTreatment");
  useEffect(() => {
    function togglePreview(type) {
      switch (type) {
        case "beforeTreatment":
          setFormulaPreview(initialDentalData);
          setFormulaPreview2(null);
          break;

        case "afterTreatment":
          setFormulaPreview(dentalData);
          setFormulaPreview2(null);
          break;

        case "beforeAndAfterTreatment":
          setFormulaPreview(dentalData);
          setFormulaPreview2(initialDentalData);
          break;

        default:
          setFormulaPreview(dentalData);
          setFormulaPreview2(null);
      }
    }

    togglePreview(previewType);
  }, [dentalData, initialDentalData, previewType]);
  const switchers = useMemo(() => {
    return [{
      type: "beforeTreatment",
      title: _t("До лечения")
    }, {
      type: "afterTreatment",
      title: _t("После лечения")
    }, {
      type: "beforeAndAfterTreatment",
      title: _t("До и после лечения")
    }];
  }, [_t]);
  return /*#__PURE__*/React.createElement("div", {
    className: "finishStep"
  }, initialDentalData && /*#__PURE__*/React.createElement("div", {
    className: "switchSceneToggle"
  }, /*#__PURE__*/React.createElement(ButtonGroup, {
    color: "primary",
    className: "switchSceneToggle-container"
  }, switchers.map(el => /*#__PURE__*/React.createElement(Button, {
    key: el.type,
    variant: previewType === el.type ? "contained" : "outlined",
    onClick: () => setPreviewType(el.type)
  }, el.title)))), /*#__PURE__*/React.createElement("div", {
    className: "finishStep-container"
  }, /*#__PURE__*/React.createElement(Formula3DPreview, {
    stlPack: formulaPreview,
    stlPack2: formulaPreview2,
    hideNotUsedSides: false,
    availableSwitchers: availableSwitchers,
    hideHeadMaskSwitcher: is3dMasksDisabled,
    headMaskEnabled: is3dMaskShowed,
    headMaskType: `${patientGender}_${patientFace}`,
    hideJawStateSwitcher: isJawStateDisabled,
    jawStateEnabled: false
  })), /*#__PURE__*/React.createElement("div", {
    className: "saveFormAction"
  }, isPatient && ["PSP_ET_e1_e2_adenty_adentyTop_adentyTopGum", "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomGum", "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothGum", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_fixedProsthetics_suspendedToothSelect_extraCrownsSelect_extraVeneersSelect_compositeRestorations_toothConnections_finishStep", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseTop_extraCrownsSelect_compositeRestorations_finishStep", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBottom_extraCrownsSelect_compositeRestorations_finishStep", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBoth_extraCrownsSelect_compositeRestorations_finishStep", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseTop_extraCrownsSelect_compositeRestorations_finishStep", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBottom_extraCrownsSelect_compositeRestorations_finishStep", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBoth_extraCrownsSelect_compositeRestorations_finishStep"].includes(stepId) && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btnPrimary selectBottomBarInfoBtn",
    onClick: generateFixedConstruction
  }, _t("Спроектировать альтернативную конструкцию")), alternateText && /*#__PURE__*/React.createElement("div", {
    className: "alternateAdentySolution"
  }, /*#__PURE__*/React.createElement("img", {
    src: require("../../assets/images/keep_attention_red_icon.png"),
    className: "alternateAdentySolution-icon",
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: "alternateAdentySolution-text",
    dangerouslySetInnerHTML: {
      __html: alternateText
    }
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btnPrimary footerAlternateBtn",
    onClick: openBottomBar
  }, _t("Подробней")))));
};

export default FinishStep;